<template>
  <div class="position-relative">
    <p style="position: absolute; top: 47px; left: calc(50% - 60px)">
      {{ $t("time_of_delivery") }}
    </p>
    <v-row class="mt-3">
      <v-col cols="1"> </v-col>
      <v-col cols="5">
        <autocomplete
          :items="setHoures"
          item-value="val"
          v-model="deliveryFrom[index]"
          :label="$t('hours')"
          @change="$emit('setDeliveryTime', index)"
        />
      </v-col>
      <v-col cols="5">
        <autocomplete
          :items="setMinutes"
          @change="$emit('setDeliveryTime', index)"
          item-value="val"
          v-model="deliveryTo[index]"
          :label="$t('minutes')"
        />
      </v-col>
    </v-row>
    <div
      class="text-right"
      style="position: absolute; top: 90px; right: -390px; font-size: 23px"
    >
      <span class="font-weight-bold"
        >Σ - {{ total[item.date] }},00
        {{ company.restaurant.settings.price }}</span
      >
      <div
        class="d-flex"
        style="
          font-size: 11px;
          background: white;
          padding: 3px;
          border: 1px solid rgba(0, 0, 0, 0.12);
          border-radius: 6px;
          align-items: center;
        "
      >
        <div class="text-right"></div>
        <div class="mr-3">
          <a
            v-if="!setUserLocation[item.date]"
            @click.prevent="$emit('showSelect', true)"
            style="
              padding: 4px 15px;
              color: rgba(0, 0, 0, 0.38);
              font-weight: 700;
              text-decoration: none;
              display: flex;
            "
            href=""
          >
            <v-icon large style="font-size: 17px" color="green darken-2"
              >mdi-domain
            </v-icon>
            <span v-if="!showSelect" class="pl-3">
              {{ $t("delivery_address") }}?
            </span>
            <select
              v-if="showSelect"
              @change="
                $emit('changeAddress', setUserLocation[item.date], item.date)
              "
              v-model="setUserLocation[item.date]"
              style="
                width: 100%;
                padding: 0 15px;
                border-radius: 1px;
                cursor: pointer;
                color: rgba(0, 0, 0, 0.6);
              "
            >
              <option v-for="address in allUserLocations" :value="address">
                {{ address.address }}
              </option>
            </select>
          </a>
          <span
            v-else
            style="
              padding: 0 15px;
              color: rgba(0, 0, 0, 0.38);
              font-weight: 700;
              text-decoration: none;
              display: flex;
            "
            class="pl-3"
          >
            <v-icon large style="font-size: 17px" color="green darken-2"
              >mdi-domain
            </v-icon>
            <span v-if="setUserLocation[item.date]">
              {{ toLatin(setUserLocation[item.date].address) }}
              <select
                @change="
                  $emit('changeAddress', setUserLocation[item.date], item.date)
                "
                v-model="setUserLocation[item.date]"
                style="
                  width: 100%;
                  padding: 0 15px;
                  border-radius: 1px;
                  cursor: pointer;
                  color: rgba(0, 0, 0, 0.6);
                "
              >
                <option
                  :selected="setUserLocation[item.date].id"
                  v-for="address in allUserLocations"
                  :value="address"
                >
                  {{ toLatin(address.address) }}
                </option>
              </select>
            </span>
          </span>
        </div>
        <div style="border-left: 1px solid rgba(0, 0, 0, 0.12)">
          <v-icon>mdi-location-radius</v-icon>
          <a
            @click.prevent="locatorButtonPressed"
            style="padding: 4px 15px; font-weight: 700; text-decoration: none"
            href=""
          >
            <v-icon style="font-size: 17px" color="green darken-2"
              >mdi-call_split</v-icon
            >
            {{
              user_location && user_location.address
                ? "Измени тренутну локацију"
                : "Промени тренутну локацију"
            }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "DeliveryAddressSelector",
  props: {
    index: Number,
    item: Object,
    total: Object,
    showSelect: Boolean,
  },
  computed: {
    ...mapState("companyMenu", [
      "deliveryFrom",
      "deliveryTo",
      "allUserLocations",
      "setUserLocation",
      "company",
      "user_location",
    ]),
    setMinutes() {
      let minutes = [];
      if (this.company && this.company.restaurant && this.company.restaurant.settings) {
        minutes.push(Number(this.company.restaurant.settings.deliveryTo));
        if (this.company.restaurant.settings.deliveryTo1 == "15") {
          minutes.push(15);
        } else if (this.company.restaurant.settings.deliveryTo1 == "30") {
          minutes.push(15, 30);
        } else if (this.company.restaurant.settings.deliveryTo1 == "45") {
          minutes.push(15, 30, 45);
        }
      }
      return minutes;
    },
    setHoures() {
      let hours = [];
      if (this.company && this.company.restaurant && this.company.restaurant.settings) {
        for (
          let i = this.company.restaurant.settings.deliveryFrom;
          i <= this.company.restaurant.settings.deliveryFrom1;
          i++
        ) {
          hours.push(Number(i));
        }
      }
      return hours;
    },
  },
  methods: {
    locatorButtonPressed() {
      navigator.geolocation.getCurrentPosition(
        (position) => {
        },
        (error) => {
          console.warn(error.message);
        }
      );
    },
  },
};
</script>
